export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div
      className="mb-8 flex flex-col gap-3 border-b border-slate-200 pb-6 sm:flex-row sm:items-end sm:justify-between"
      data-testid={testId || "page-header"}
    >
      <div>
        <h1
          className="font-heading text-3xl font-semibold tracking-tight text-slate-900"
          data-testid="page-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-sm text-slate-500" data-testid="page-subtitle">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
